import API from 'services/api';

export const getOfficeDetails = (officeId: string | null) => {
  return API.get(`/api/offices/${officeId}`).then(res => res?.data);
};
